import type { ImageDesignTokens, ImageTokenSections } from '@openng/optimus-ui-themes/types/image';

export const toolbar: ImageTokenSections.Toolbar = {
	background: '{named.image.toolbar.background}',
	borderColor: '{named.image.toolbar.border.color}',
	padding: '0.5rem',
};

export const action: ImageTokenSections.Action = {
	hoverBackground: '{named.image.action.hover.background}',
	borderRadius: '{image.action.size} / 2',
};

export default {
	toolbar,
	action,
} satisfies ImageDesignTokens;
